<template>
  <form id="frm_action">
  <div class="p-formgrid">
        <div class="p-card-field">
          <div class="p-field p-grid">
            <label class="p-col-fixed txt-right">Tỉnh/ Thành phố (*)</label>
            <div class="p-col">
              <InputText disabled v-model="name" type="text" id="name_add" class="p-col-width" placeholder="Nhập tiêu đề video"/>
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed txt-right">Thứ tự hiển thị</label>
            <div class="p-col">
              <InputNumber v-model="ordinal" id='tmp_ttht' class="p-col-width"/>
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed txt-right"></label>
            <div class="p-col">
              <Checkbox v-model="checkedActive" :binary="true" />
              <label for="binary" class="text-active">Hiển thị</label>
            </div>
          </div>
        </div>

    <Toolbar class="fixed-bottom-toolbar">
      <template slot="right">
        <Button
          label="Quay lại"
          @click="backToList()"
          class="p-button-warning"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
        <Button
          v-else
          :label="'Thêm mới'"
          @click="saveData()"
          class="p-button-success"
        />
      </template>
    </Toolbar>
  </div>
  </form>
</template>

<script>
export default {
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      name: '',
      checkedActive : false,
      ordinal : 1,
      validationErrors: {},
      formMode: this.mode,
      images: [],
      imagesDeletes: [],
      maxFileSize: 1000000, // 1MB
      maxFiles: 10,
      saving:false,
      content : '',
      imgDelete : [],
    }
  },
  mounted() {
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
       console.log("this.model",this.model)
      this.name = this.model.name;
      this.checkedActive = this.model.active;
      this.ordinal = this.model.ordinal;
    }
  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    handleDataCkditor: function(e,key) {
      var dataContent = (e.length) ? e[0]:'';
      if (key == 'content'){
        this.content = dataContent;
      }
    },
    CallPhoneSel(){
      if(this.selUser !== undefined && this.selUser !== null){
        this.phone = this.selUser.phone
      }
    },
    async validateData() {
      let tmp_ttht = document.getElementById("tmp_ttht");
      if (this.ordinal == undefined || this.ordinal == null || this.ordinal < 0){
        tmp_ttht.setCustomValidity("Nhập thứ tự hiển thị");
      }else{
        tmp_ttht.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()){
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }

    },
  
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return
      }
      
      var params = {
        name: this.name,
        images: this.images,
        imagesDeletes: this.imgDelete,
        active :this.checkedActive,
        ordinal : this.ordinal
      }
        //  console.log("params",params)
      this.$emit('save', params);
      
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 450px;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .p-invalid {
    color: red;
    margin: 1px 0px 0px 0px;
  }
  .text-active{
    margin: 0px 0px 0px 8px;
  }
  
  </style>
